import Notification from './src/main.js';
export default Notification;



// WEBPACK FOOTER //
// ./src/components/element/packages/notification/index.js